import React from 'react';
import PropTypes from 'prop-types';

import DataModel from '../../../models/DataModel';
import Hammer from 'hammerjs';

import './FeatureWalkthrough.scss';

export default class FeatureWalkthrough extends React.Component {

  constructor(props) {
    FeatureWalkthrough.propTypes = {
      /**
       *  array of Step objects
       *  Step: {
       *    imgSrc: src for main tutorial image,
       *    text: text to display below the image 
       *  }
       **/
      steps: PropTypes.arrayOf(PropTypes.object).isRequired,
      onClose: PropTypes.func,
    };
    super(props);

    this.state = {
      /** matches an index of props.steps */
      currentStepNumber: 0,
      /** used to trigger quick fade animation on close */
      closing: false,
    };
    // Ref to container used to detect mobile swipe gestures
    this.swipeContainer = null;

    this.goToNextStep = this.goToNextStep.bind(this);
    this.goToPreviousStep = this.goToPreviousStep.bind(this);
    this.initiateClose = this.initiateClose.bind(this);
  }

  componentDidMount() {
    const swipeArea = new Hammer(this.swipeContainer);
    swipeArea.on('swipe', swipeEvent => {
      if (swipeEvent.direction == Hammer.DIRECTION_LEFT) {
        this.goToNextStep();
      }
      else if (swipeEvent.direction == Hammer.DIRECTION_RIGHT) {
        this.goToPreviousStep();
      }
    });
  }

  goToPreviousStep() {
    const { currentStepNumber } = this.state;
    const onFirstStep = (currentStepNumber == 0);
    if (!onFirstStep) {
      this.setState({ currentStepNumber: currentStepNumber - 1 });
    }
  }

  goToNextStep() {
    const { currentStepNumber } = this.state;
    const onLastStep = (currentStepNumber == (this.props.steps.length - 1));
    if (!onLastStep) {
      this.setState({ currentStepNumber: currentStepNumber + 1 });
    }
  }

  initiateClose(e) {
    e.stopPropagation();
    this.setState({ closing: true });
  }

  render() {
    const { steps, onClose } = this.props;
    const { currentStepNumber, closing } = this.state;

    const currentStep = steps[currentStepNumber];
    const onLastStep = (currentStepNumber == (steps.length - 1));

    let baseClassName = 'feature-walkthrough';
    if (closing) {
      // Trigger animation and delayed close
      baseClassName += ' feature-walkthrough--closing';
      setTimeout(() => {
        onClose();
        DataModel.hideGlobalModal();
      }, 500);
    }

    let dotIndicators = steps.map((step, index) => {
      const isActive = (index == currentStepNumber);
      return (
        <span className={'nav-dot' + (isActive ? ' nav-dot--active' : '')} key={'step='+index}/>
      );
    });
    return (
      <article className={baseClassName} ref={el => this.swipeContainer = el}>
        <img className="feature-walkthrough__img" src={currentStep.imgSrc} alt="tutorial_graphic"/>
          <span className="feature-walkthrough__text">
            <h3>{currentStep.text}</h3>
          </span>
          <div className="feature-walkthrough__nav">
            {dotIndicators}
          </div>
          <span className="feature-walkthrough__skip-button" onClick={this.initiateClose}>
            {onLastStep ? 'DONE' : 'SKIP'}
          </span>
      </article>
    );
    
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/FeatureWalkthrough/index.js